import * as actionTypes from '../actions/actionTypes';

const initialState = {
    ingredients: null,
    totalPrice: 4,
    error: false,
    building: false,
    authRedirectionPath: '/'
};

const INGREDIENTS_PRICE = {
    salad: 0.6,
    bacon: 1.1,
    cheese: 0.8,
    meat: 1.6

}

const addIngredient = (state, action ) => {
    return {
        ...state,
        ingredients: {
            ...state.ingredients,
            [action.ingredientName]: state.ingredients[action.ingredientName] + 1
        },
        totalPrice: state.totalPrice + INGREDIENTS_PRICE[action.ingredientName],
        building: true
    }
};

const removeIngredient = (state, action ) => {
    return {
        ...state,
        ingredients: {
            ...state.ingredients,
            [action.ingredientName]: state.ingredients[action.ingredientName] - 1
        },
        totalPrice: state.totalPrice + INGREDIENTS_PRICE[action.ingredientName],
        building: true
    }
};

const setIngridients =( state, action ) => {
    return {
        ...state,
        ingredients: {
            salad: action.ingridients.salad,
            bacon: action.ingridients.bacon,
            cheese: action.ingridients.cheese,
            meat: action.ingridients.meat
        },
        totalPrice: 4,
        error: false,
        building: false
    }
};

const fetchIngridients = ( state, action ) => {
    return {
        ...state,
        error: true
    }
};

const burgerBuilder = (state = initialState, action) => {
    switch (action.type) {

        case actionTypes.ADD_INGRIDIENT: return addIngredient(state, action);            

        case actionTypes.REMOVE_INGRIDIENT: return removeIngredient(state, action);

        case actionTypes.SET_INGRIDIENTS: return setIngridients( state, action );  

        case actionTypes.FETCH_INGRIDIENTS_FAILED:  return fetchIngridients( state, action );  
        
        default: return state;
    }
};

export default burgerBuilder;